type DateValue = {
  valueOf: () => number;
};

const EXPIRATION_DATE_PERIODICITIES = ['not_defined', 'defined'];

const startOfToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

const endOfExpirationDay = (expirationDays: number) => {
  const expirationDate = startOfToday();
  expirationDate.setDate(expirationDate.getDate() + expirationDays);
  expirationDate.setHours(23, 59, 59, 999);
  return expirationDate;
};

export const isExpirationDateDisabled = (
  current: DateValue | null | undefined,
  expirationDays?: number | null,
) => {
  if (!current) return false;

  const currentValue = current.valueOf();
  if (currentValue < startOfToday().valueOf()) return true;
  if (expirationDays === null || expirationDays === undefined) return false;

  return currentValue > endOfExpirationDay(expirationDays).valueOf();
};

export const shouldShowExpirationDate = (periodicity?: string | null) => (
  EXPIRATION_DATE_PERIODICITIES.includes(periodicity || '')
);

export const hasExpirationDays = (expirationDays?: number | null) => (
  expirationDays !== null && expirationDays !== undefined
);
